module.exports = __webpack_public_path__ + "static/Benidorm-ad748d047f11417e8545c634d6f0ee71.jpg";